export const STATUS_FIELDS = {

    IN_STOCK: [
        {
            name: "warehouseNameId",
            label: "Warehouse Name",
            type: "autocomplete",
            optionsKey: "warehouseNames",
            required: true
        }
        // {
        //     name: "warehouseLocation",
        //     label: "Warehouse Location / Bin",
        //     required: false
        // }
    ],

    IN_USE: [
        {
            name: "assignedUserId",
            label: "Assigned User",
            type: "autocomplete",
            optionsKey: "users",
            required: true
        },
        {
            name: "assignmentDate",
            label: "Assignment Date",
            type: "date",
            required: true
        },
        {
            name: "assignmentTypeId",
            label: "Assignment Type",
            type: "select",
            optionsKey: "assignmentTypes",
            required: true

        },
        {
            name: "departmentId",
            label: "Department",
            type: "select",
            optionsKey: "departments",
            required: true
        }
    ],

    RESERVED: [
        {
            name: "reservedForUserId",
            label: "Reserved For",
            type: "userAutocomplete",
            required: true
        },
        {
            name: "relatedRequestId",
            label: "Related Request",
            type: "ticketAutocomplete",
            required: false
        },
        {
            name: "reservationDate",
            label: "Reservation Date",
            type: "date",
            required: true
        },
        {
            name: "expectedAssignmentDate",
            label: "Expected Assignment Date",
            type: "date",
            required: false
        },
        {
            name: "warehouseNameId",
            label: "Warehouse Name",
            type: "autocomplete",
            optionsKey: "warehouseNames",
            required: true
        }
    ],

    UNDER_MAINTENANCE: [
        {
            name: "maintenanceTypeId",
            label: "Maintenance Type",
            type: "select",
            optionsKey: "maintenanceTypes",
            required: true
        },
        {
            name: "maintenanceVendorId",
            label: "Maintenance Vendor",
            type: "select",
            optionsKey: "vendors",
            required: false
        },
        {
            name: "maintenanceStartDate",
            label: "Maintenance Start Date",
            type: "date",
            required: true
        },
        {
            name: "expectedReturnDate",
            label: "Expected Return Date",
            type: "date",
            required: false
        },
        {
            name: "maintenanceReference",
            label: "Maintenance Reference",
            required: false
        }
    ],

    PENDING_RETURN: [
        // {
        //     name: "assignedUserId",
        //     label: "Current Assigned User",
        //     type: "user",
        //     required: true
        // },
        {
            name: "expectedReturnDate",
            label: "Expected Return Date",
            type: "date",
            required: true
        },
        {
            name: "returnReason",
            label: "Return Reason",
            required: false
        }
    ],

    LOST_STOLEN: [
        // {
        //     name: "lastAssignedUserId",
        //     label: "Last Assigned User",
        //     type: "user",
        //     required: true
        // },
        {
            name: "dateReported",
            label: "Date Reported",
            type: "date",
            required: true
        },
        {
            name: "reportedById",
            label: "Reported By",
            type: "userAutocomplete",
            required: true
        },
        {
            name: "incidentTicketId",
            label: "Incident / Ticket",
            type: "ticketAutocomplete",
            required: false
        },
        {
            name: "lossTypeId",
            label: "Loss Type",
            type: "select",
            optionsKey: "lostTypes",
            required: true
        },
        {
            name: "remarks",
            label: "Remarks",
            multiline: true,
            required: true
        }
    ],

    RETIRED: [
        {
            name: "retirementDate",
            label: "Retirement Date",
            type: "date",
            required: true
        },
        {
            name: "retirementReason",
            label: "Retirement Reason",
            required: true
        },
        {
            name: "retirementApprovedById",
            label: "Retirement Approved By",
            type: "userAutocomplete",            
            required: false
        },
        {
            name: "disposalDecision",
            label: "Disposal Decision",
            required: false
        }
    ],

    PENDING_DISPOSAL: [
        {
            name: "disposalInitiatedDate",
            label: "Disposal Initiated Date",
            type: "date",
            required: true
        },
        {
            name: "disposalReason",
            label: "Disposal Reason",
            required: true
        },
        {
            name: "disposalMethodId",
            label: "Disposal Method",
            type: "select",
            optionsKey: "disposalMethods",
            required: false
        },
        {
            name: "disposalVendorId",
            label: "Disposal Vendor",
            type: "select",
            optionsKey: "vendors",
            required: false
        },
        {
            name: "approvalReference",
            label: "Approval Reference",
            required: false
        }
    ],

    DISPOSED: [
        {
            name: "disposalDate",
            label: "Disposal Date",
            type: "date",
            required: true
        },
        {
            name: "disposalMethodId",
            label: "Disposal Method",
            type: "select",
            optionsKey: "disposalMethods",
            required: false
        },
        {
            name: "disposalVendorId",
            label: "Disposal Vendor",
            type: "select",
            optionsKey: "vendors",
            required: false
        },
        {
            name: "disposalReference",
            label: "Disposal Reference",
            required: false
        }
    ]
};